import React from 'react';

import classNames from 'classnames';

import UserPicture from '@/components/Common/UserPicture';

import FieldValue from './FieldValue';

const FieldRow = ({ item, itemKey, formatMessage, styles, tooltip, onCopy }) => {
  const isCenteredAvatar = item.hideLabel && (item.type === 'user-photo' || item.type === 'photo');
  if (isCenteredAvatar) {
    const { size, shape, fullName } = item.viewProps || {};
    const isUserPhoto = item.type === 'user-photo';
    if (isUserPhoto && !item.value) return null;
    if (!isUserPhoto && !item.value && !fullName) return null;
    return (
      <div className={styles.userPhotoOnly}>
        <UserPicture
          id={isUserPhoto ? item.value : undefined}
          iconUrl={isUserPhoto ? undefined : item.value || undefined}
          fullName={fullName}
          name={fullName}
          size={size || 98}
          shape={shape || 'circle'}
          showTooltip={false}
        />
      </div>
    );
  }

  const isSwitch = item.type === 'switch';
  const hideLabel = item.hideLabel;
  const rowClass = classNames(
    styles.fieldRow,
    isSwitch && styles.fieldRowSwitch,
    hideLabel && styles.fieldRowMedia,
  );
  const labelClass = styles.fieldLabel;
  const valueClass = styles.fieldValue;

  const value = (
    <FieldValue
      item={item}
      itemKey={itemKey}
      formatMessage={formatMessage}
      styles={styles}
      tooltip={tooltip}
      onCopy={onCopy}
    />
  );

  if (hideLabel) {
    return (
      <div className={rowClass}>
        <dd className={valueClass}>{value}</dd>
      </div>
    );
  }

  const labelAction = item.labelAction;
  const ActionIcon = labelAction?.Icon;
  const label = (
    <>
      <span>
        {formatMessage({ id: item.label })}
        {item.labelSuffix ? ` ${item.labelSuffix}` : null}
      </span>
      {labelAction?.href && labelAction?.labelId ? (
        <a
          href={labelAction.href}
          target={labelAction.target || '_blank'}
          rel="noopener noreferrer"
          className={styles.labelAction}
        >
          {ActionIcon ? <ActionIcon /> : null}
          {formatMessage({ id: labelAction.labelId })}
        </a>
      ) : null}
    </>
  );

  return (
    <div className={rowClass}>
      <dt className={classNames(labelClass, labelAction?.href && styles.fieldLabelWithAction)}>
        {label}
      </dt>
      <dd className={valueClass}>{value}</dd>
    </div>
  );
};

export default FieldRow;
